module.exports = __webpack_public_path__ + "img/白背景top.981d254a.png";